import { Link, useParams, useSearchParams } from "react-router-dom";
import { DEMO_PASSWORD } from "../domain/auth";
import { localDevShortcutsEnabled, runtimeFromBrowser } from "../domain/env";
import { useAuth } from "../state/AuthProvider";
import { useForms } from "../state/forms";
import { useLocale } from "../state/i18n";
import { useMail } from "../state/MailProvider";
import { useStudents } from "../state/students";
import { PrototypeBanner, PublicNav } from "../components/ui";

export function RegisterDone() {
  const { studentId = "" } = useParams();
  const { getStudent } = useStudents();
  const { currentForm, submissionForStudent } = useForms();
  const { familyMailFor } = useMail();
  const { account } = useAuth();
  const { t } = useLocale();
  const [params] = useSearchParams();
  const showDevShortcuts = localDevShortcutsEnabled(
    runtimeFromBrowser().name,
    `?${params.toString()}`,
  );
  const student = getStudent(studentId);
  const mail = familyMailFor(studentId);
  const submission =
    currentForm && student
      ? submissionForStudent(currentForm.id, student.id)
      : undefined;

  if (!student) {
    return (
      <div className="app">
        <PrototypeBanner />
        <main className="shell">
          <PublicNav />
          <p>{t("done.notFound")}</p>
          <Link to="/register">{t("done.register")}</Link>
        </main>
      </div>
    );
  }

  return (
    <div className="app">
      <PrototypeBanner />
      <main className="shell">
        <PublicNav />
        <p className="meta">{t("done.meta")}</p>
        <h1>{t("done.title", { name: student.given })}</h1>
        <p className="lede">
          {t("done.lede", { school: student.school })}
        </p>

        {currentForm && submission ? (
          <div className="wire">
            <div className="meta">{t("done.saved")}</div>
            <strong>{currentForm.name}</strong>
            <div className="anno">
              {t("done.submitted", { date: submission.submittedLabel })}
            </div>
          </div>
        ) : null}

        {mail ? (
          <div className="wire auth-mail" style={{ marginTop: "1rem" }}>
            <div className="meta">{t("done.mailMeta")}</div>
            <strong>{mail.subject}</strong>
            <div className="anno">
              {t("done.mailNote", { email: mail.to.join(", ") })}
            </div>
            <p className="mail-body">{mail.body}</p>
          </div>
        ) : (
          <div className="wire dashed" style={{ marginTop: "1rem" }}>
            <div className="meta">{t("done.next")}</div>
            <p style={{ margin: "0.5rem 0 0" }}>{t("done.nextBody")}</p>
            {showDevShortcuts ? (
              <p style={{ margin: "0.5rem 0 0" }}>
                {t("done.demo", { email: student.email, password: DEMO_PASSWORD })}
              </p>
            ) : null}
          </div>
        )}

        <div className="actions">
          {account?.role === "parent" ? (
            <Link className="btn" to="/family">
              {t("done.openFamily")}
            </Link>
          ) : null}
          <Link className="btn" to={`/student/${student.id}`}>
            {t("done.openLanding")}
          </Link>
          <Link className="btn ghost" to="/signin">
            {t("done.signIn")}
          </Link>
          <Link className="btn ghost" to="/">
            {t("nav.home")}
          </Link>
        </div>
      </main>
    </div>
  );
}
